import { createGlobalStyle } from 'styled-components';

export const MultipleActionsGlobalStyles = createGlobalStyle`
    .elements-container {
        width: 165px;
        padding: 4px 4px 4px 5px;
        
    }
`;
